export const TOKEN_KEY = "steeldart-admin-token";

export function loadAdminToken(): string | null {
  return sessionStorage.getItem(TOKEN_KEY);
}

export function saveAdminToken(token: string | null): void {
  if (token) sessionStorage.setItem(TOKEN_KEY, token);
  else sessionStorage.removeItem(TOKEN_KEY);
}

/** Same-origin /api on the public site — never the internal Node bind port from /api/info. */
export function adminApi(apiBase: string, path: string): string {
  if (typeof location !== "undefined" && location.protocol !== "file:") {
    if (!apiBase) return path;
    try {
      if (new URL(apiBase).hostname === location.hostname) return path;
    } catch {
      /* relative or invalid base */
    }
  }
  if (!apiBase) return path;
  return `${apiBase.replace(/\/+$/, "")}${path}`;
}

